import { API_BASE_URL } from '../config';

export type MasterOption = {
  value: string;
  label: string;
};

export type MasterDataResponse = {
  data: MasterOption[];
  success: boolean;
  message?: string;
}

// 職業形態の取得
export const fetchJobOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=job`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('職業形態の取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('職業形態の取得エラー:', error);
    throw error;
  }
};

// 業種の取得
export const fetchIndustryOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=industry`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('業種の取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('業種の取得エラー:', error);
    throw error;
  }
};

// 二拠点居住の目的の取得
export const fetchPurposeOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=purpose`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('二拠点居住の目的の取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('二拠点居住の目的の取得エラー:', error);
    throw error;
  }
};

export const fetchInquiryOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=inquiry_type`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('問い合わせ種別の取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('問い合わせ種別の取得エラー:', error);
    throw error;
  }
};

export const fetchInquiryUserTypeOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=inquiry_user_category`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('問い合わせ種別の取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('問い合わせ種別の取得エラー:', error);
    throw error;
  }
};

// メールオプトインの取得
export const fetchMailOptOptions = async (): Promise<MasterOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/options?master_name=mail_opt`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('メールオプトの取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('メールオプトの目的の取得エラー:', error);
    throw error;
  }
};